var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_41294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5362 22.743H21.9997C21.593 22.743 21.2558 22.4058 21.2558 21.9991V15.4626C21.2558 14.9171 20.8094 14.4707 20.2639 14.4707C17.7445 14.4707 15.3838 15.4626 13.6282 17.2777C11.8626 19.083 10.9303 21.4734 10.9997 24.0027C11.1287 28.8332 15.1656 32.8702 19.9961 32.9991C20.0854 32.9991 20.1746 32.9991 20.2639 32.9991C22.694 32.9991 24.9754 32.0767 26.7211 30.3805C28.5263 28.6249 29.5281 26.2642 29.5281 23.7448C29.5281 23.1993 29.0818 22.7529 28.5362 22.7529V22.743ZM25.3424 28.9522C23.924 30.3309 22.0592 31.055 20.0655 31.0054C16.2765 30.8963 13.1025 27.7322 12.9934 23.9432C12.9339 21.9594 13.6679 20.0848 15.0466 18.6565C16.1972 17.4761 17.6652 16.7322 19.272 16.514V21.9892C19.272 23.4969 20.492 24.7169 21.9997 24.7169H27.4749C27.2567 26.3237 26.5227 27.7917 25.3324 28.9423L25.3424 28.9522Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.736 11C23.1905 11 22.7441 11.4463 22.7441 11.9919V20.2642C22.7441 20.8097 23.1905 21.2561 23.736 21.2561H32.0083C32.5539 21.2561 33.0002 20.8097 33.0002 20.2642C33.0002 15.156 28.8442 11 23.736 11ZM24.7279 19.2723V13.0532C27.9515 13.4896 30.5106 16.0487 30.947 19.2723H24.7279Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_41294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/Stats.f52b1eefe5413b5834f5c59970c52b80.svg";
export { ForwardRef as ReactComponent };